import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/auth', { replace: true });
      return;
    }

    const processSession = async () => {
      try {
        const user = await loginWithGoogle(sessionId);
        // Navigate to gallery (main app) with user data
        navigate('/gallery', { replace: true, state: { user } });
      } catch (err) {
        console.error('Google auth error:', err);
        navigate('/auth', { replace: true });
      }
    };

    processSession();
  }, [location.hash, loginWithGoogle, navigate]);

  // Silent processing - minimal UI
  return (
    <div className="min-h-screen bg-texture flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 size={32} className="text-[--ch-cyan] animate-spin mx-auto mb-3" />
        <p className="text-sm text-[--ch-text-secondary]">Signing you in...</p>
      </div>
    </div>
  );
}
